'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _FilterCollection = require('../../Filters/FilterCollection');

var _FilterCollection2 = _interopRequireDefault(_FilterCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _FilterCollection2.default)('homes')('OpenHouse', {
  filter: function filter(home, _ref) {
    var values = _ref.values;

    var hasOpenHouse = _fp2.default.map(function (openHouse) {
      return (0, _moment2.default)(_fp2.default.get('date', openHouse));
    })(_fp2.default.getOr([], 'openHouses', home)).reduce(function (result, date) {
      if (!result && date.isValid() && date.isSameOrAfter((0, _moment2.default)(), 'day')) {
        return true;
      }

      return result;
    }, false);

    return values.map(function (val) {
      return val.value;
    }).includes(hasOpenHouse);
  },
  collectValues: function collectValues() {
    return [{
      label: 'Yes',
      value: true
    }, {
      label: 'No',
      value: false
    }];
  },

  labelRender: function labelRender(_ref2) {
    var label = _ref2.label;
    return label;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/filters/OpenHouse.js
// module id = 661
// module chunks = 0